import { RootState } from "common/rootReducer";
import { AuthContext } from "common/services/auth-service";
import {
  CHECKIN_EVENT,
  CHECKIN_EVENT_DETAILS,
  RESTAURANT_MENU_VIEW_EVENT_DETAILS,
  FirebaseEventType,
  FirebaseEventDetailsType,
  RESTAURANT_MENU_VIEW_EVENT,
  RESTAURANT_CAMPAIGN_VIEW_EVENT_DETAILS,
  RESTAURANT_CAMPAIGN_VIEW_EVENT,
} from "firebase/analytics/events";
import { useContext } from "react";
import { useSelector } from "react-redux";
import { useFirebaseAnalytics } from "./useAnalyticsService";

export function useEventLogger(): [
  (type: FirebaseEventType, details: FirebaseEventDetailsType) => void
] {
  const appAuth = useContext(AuthContext);
  const restaurantSlug = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantSlug
  );
  const firebaseAnalytics = useFirebaseAnalytics();

  const logEvent = (
    eventType: FirebaseEventType,
    eventDetail: FirebaseEventDetailsType
  ) => {
    switch (eventType) {
      case "checkin_register":
        // console.log("CheckIn Log", restaurantSlug, appAuth?.userAuth?.id);
        firebaseAnalytics.logEvent(CHECKIN_EVENT, {
          merchant: restaurantSlug,
          userId: appAuth?.userAuth?.id || "",
        } as CHECKIN_EVENT_DETAILS);
        break;
      case "restaurant_menu_view":
        const resMenuViewData = eventDetail as RESTAURANT_MENU_VIEW_EVENT_DETAILS;
        // console.log("Menu View Log", data);
        firebaseAnalytics.logEvent(RESTAURANT_MENU_VIEW_EVENT, {
          merchant: resMenuViewData.merchant,
        } as CHECKIN_EVENT_DETAILS);
        break;
      case "restaurant_campaign_view":
        const resCampaignViewData = eventDetail as RESTAURANT_CAMPAIGN_VIEW_EVENT_DETAILS;
        firebaseAnalytics.logEvent(RESTAURANT_CAMPAIGN_VIEW_EVENT, {
          merchant: resCampaignViewData.merchant,
          campaignId: resCampaignViewData.campaignId,
        } as RESTAURANT_CAMPAIGN_VIEW_EVENT_DETAILS);
        break;
      default:
        break;
    }
  };

  return [logEvent];
}
